
import { supabase } from '@/lib/supabase';
import { DetectionResult } from './mlServiceTypes';
import { monitorApiCall } from '@/utils/monitoring';

export const textAnalysisService = {
  checkOriginality: async (text: string, model: string = 'auto'): Promise<DetectionResult> => {
    try {
      return await monitorApiCall(
        (async () => {
          const { data, error } = await supabase.functions.invoke('detect-text', {
            body: { text, analysisType: 'originality', model }
          });
          
          if (error) throw error;
          
          return {
            score: data.score,
            confidence: data.confidence,
            flags: data.flags || [],
            explanation: data.explanation,
            modelName: data.modelName || "Text Originality Checker",
            timestamp: new Date(data.timestamp || Date.now()),
            textMetrics: data.textMetrics,
            id: data.id
          };
        })(),
        'checkOriginality'
      );
    } catch (error) {
      console.error("Originality check error:", error);
      return {
        score: 0.1,
        confidence: 0.5,
        flags: ["Analysis failed"],
        explanation: "We couldn't complete the originality check due to a technical error.",
        modelName: "Error Recovery",
        timestamp: new Date()
      };
    }
  }
};
